import PropTypes from 'prop-types';
import DropdownService from '../services/dropdown-service';

export default PropTypes.oneOf(DropdownService.getValidPositions());
